import '../index.scss';
import { useEffect, useState, FC } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
} from '@material-ui/core';
import { Select } from '@sharedComponents/DesignSystem/Inputs';
import { getSubmissionGroupListSelector } from '@selectors/submissionGroups';
import { translate } from '@utils';
import { MgState } from '@types';

interface Props {
  open: boolean;
  title: string;
  handleCancel?: () => void;
  handleConfirmation?: (groupId: string) => void;
}

export const ReassignSubmissionsGroupModal: FC<Props> = ({
  title,
  open,
  handleCancel,
  handleConfirmation,
}) => {
  const [groupTemplateId, setGroupTemplateId] = useState<string>();
  const isReassignSubmissionsGroupLoading = useSelector<MgState, boolean>(
    ({ submission }) => submission.isReassignSubmissionsGroupLoading
  );

  const submissionGroups = useSelector(getSubmissionGroupListSelector);

  useEffect(() => {
    setGroupTemplateId(null);
  }, [open]);

  const handleOnGroupTemplateIdChange = (value: string) => setGroupTemplateId(value);

  return (
    <Dialog className="reassign-modal-group" keepMounted open={open} onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className="reassign-modal-group-content">
        <FormControl variant="standard">
          <FormLabel className="reassign-modal-group-content__group">
            {translate('move_to')}
          </FormLabel>
          <Select
            value={groupTemplateId}
            handleChange={handleOnGroupTemplateIdChange}
            options={submissionGroups.map((option) => ({ label: option.name, value: option.id }))}
            placeholder={translate('choose')}
          />
        </FormControl>
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button
          className="actions-button save"
          onClick={() => handleConfirmation(groupTemplateId)}
          disabled={isReassignSubmissionsGroupLoading || !groupTemplateId}
          disableRipple
        >
          {translate('move')}
        </Button>
        <Button className="actions-button cancel" onClick={handleCancel} disableRipple>
          {translate('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
